import type { ThrowClipFrame } from './throwCapability'

export interface ThrowClipState {
  active: boolean
  frameIndex: number
  elapsedMs: number
  fishIndex: 0 | 1 | null
}

export type ThrowClipEvent =
  | { type: 'release'; fishIndex: 0 | 1 }
  | { type: 'complete'; fishIndex: 0 | 1 }

export function createThrowClipState(): ThrowClipState {
  return { active: false, frameIndex: 0, elapsedMs: 0, fishIndex: null }
}

export function beginThrowClip(state: ThrowClipState, fishIndex: 0 | 1): ThrowClipState {
  if (state.active) return state
  return { active: true, frameIndex: 0, elapsedMs: 0, fishIndex }
}

export function advanceThrowClip(
  state: ThrowClipState,
  deltaMs: number,
  frames: readonly ThrowClipFrame[],
): { state: ThrowClipState; events: ThrowClipEvent[] } {
  if (!state.active || state.fishIndex === null || frames.length === 0) {
    return { state, events: [] }
  }

  const events: ThrowClipEvent[] = []
  let frameIndex = state.frameIndex
  let elapsedMs = state.elapsedMs + Math.max(0, deltaMs)
  const fishIndex = state.fishIndex

  while (elapsedMs >= frames[frameIndex].durationMs) {
    elapsedMs -= frames[frameIndex].durationMs
    frameIndex++
    if (frameIndex >= frames.length) {
      events.push({ type: 'complete', fishIndex })
      return { state: createThrowClipState(), events }
    }
    if (frames[frameIndex].events.includes('release')) {
      events.push({ type: 'release', fishIndex })
    }
  }

  return {
    state: { active: true, frameIndex, elapsedMs, fishIndex },
    events,
  }
}
